export default __webpack_public_path__ + "static/media/undraw_loading.9c5f04fe.svg";